export default __webpack_public_path__ + "static/media/ELIKSIR-00252.59bece1c.JPG";